import { render, staticRenderFns } from "./bsummit.vue?vue&type=template&id=1c8f703c&scoped=true&"
import script from "./bsummit.vue?vue&type=script&lang=js&"
export * from "./bsummit.vue?vue&type=script&lang=js&"
import style0 from "./bsummit.vue?vue&type=style&index=0&id=1c8f703c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f703c",
  null
  
)

export default component.exports